import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import zhTWHome from './locales/zh-TW/home.json';
import enHome from './locales/en/home.json';
import zhTWBooking from './locales/zh-TW/booking.json';
import enBooking from './locales/en/booking.json';
import zhTWLogin from './locales/zh-TW/login.json';
import enLogin from './locales/en/login.json';
import zhTWAdmin from './locales/zh-TW/admin.json';
import enAdmin from './locales/en/admin.json';
import zhTWOrders from './locales/zh-TW/orders.json';
import enOrders from './locales/en/orders.json';
import zhTWSchedule from './locales/zh-TW/schedule.json';
import enSchedule from './locales/en/schedule.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'zh-TW': {
        home: zhTWHome,
        booking: zhTWBooking,
        login: zhTWLogin,
        admin: zhTWAdmin,
        orders: zhTWOrders,
        schedule: zhTWSchedule,
      },
      en: {
        home: enHome,
        booking: enBooking,
        login: enLogin,
        admin: enAdmin,
        orders: enOrders,
        schedule: enSchedule,
      },
    },
    lng: 'zh-TW',
    fallbackLng: 'zh-TW',
    ns: ['home', 'booking', 'login', 'admin', 'orders', 'schedule'],
    defaultNS: 'home',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
